import { render } from "./patchStockModel.vue?vue&type=template&id=60321dc4"
import script from "./patchStockModel.vue?vue&type=script&lang=js"
export * from "./patchStockModel.vue?vue&type=script&lang=js"

import "./patchStockModel.vue?vue&type=style&index=0&id=60321dc4&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__